import { render, staticRenderFns } from "./period-component.vue?vue&type=template&id=ec572204&scoped=true&"
import script from "./period-component.vue?vue&type=script&lang=js&"
export * from "./period-component.vue?vue&type=script&lang=js&"
import style0 from "./period-component.vue?vue&type=style&index=0&id=ec572204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec572204",
  null
  
)

export default component.exports